/** Apply Bixoto/admin accent color as CSS variables on document root */
export function applySiteAccentColor(hex: string, target: HTMLElement | Document = document): void {
  const root = target instanceof Document ? target.documentElement : target;
  const normalized = normalizeHex(hex);
  if(!normalized) return;
  root.style.setProperty("--cc-bx-accent", normalized);
  root.style.setProperty("--cc-bx-accent-hover", darkenHex(normalized, 0.15));
  root.style.setProperty("--cc-bx-accent-soft", `${normalized}1a`);
  const hsl = hexToHsl(normalized);
  if(hsl) {
    root.style.setProperty("--primary", `${hsl.h} ${hsl.s}% ${hsl.l}%`);
    root.style.setProperty("--ring", `${hsl.h} ${hsl.s}% ${hsl.l}%`);
    root.style.setProperty("--sidebar-accent", `${hsl.h} ${hsl.s}% ${hsl.l}%`);
  }
}

function normalizeHex(input: string): string | null {
  const raw = input.trim();
  if(/^#[0-9a-fA-F]{6}$/.test(raw)) return raw.toLowerCase();
  if(/^#[0-9a-fA-F]{3}$/.test(raw)) {
    return `#${raw[1]}${raw[1]}${raw[2]}${raw[2]}${raw[3]}${raw[3]}`.toLowerCase();
  }
  return null;
}

function hexToHsl(hex: string): {h: number; s: number; l: number} | null {
  const m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex);
  if(!m) return null;
  const r = parseInt(m[1], 16) / 255;
  const g = parseInt(m[2], 16) / 255;
  const b = parseInt(m[3], 16) / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h = 0;
  let s = 0;
  const l = (max + min) / 2;
  if(max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch(max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      default: h = (r - g) / d + 4;
    }
    h /= 6;
  }
  return {h: Math.round(h * 360), s: Math.round(s * 100), l: Math.round(l * 100)};
}

function darkenHex(hex: string, amount: number): string {
  const m = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex);
  if(!m) return hex;
  const clamp = (n: number) => Math.max(0, Math.min(255, Math.round(n * (1 - amount))));
  return `#${clamp(parseInt(m[1], 16)).toString(16).padStart(2, "0")}${clamp(parseInt(m[2], 16)).toString(16).padStart(2, "0")}${clamp(parseInt(m[3], 16)).toString(16).padStart(2, "0")}`;
}
